import {Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatSort} from '@angular/material/sort';
import {Product} from '../models/product';
import {AnnuityDialogComponent} from './dialogs/annuity-dialog/annuity-dialog.component';
import {AnnuityService} from '../services/annuity.service';
import {Router} from '@angular/router';
import {MemberService} from '../services/member.service';
import {SubcategoryService} from '../services/subcategory.service';

@Component({
  selector: 'app-annuity',
  templateUrl: './annuity.component.html',
  styleUrls: [ './annuity.component.scss' ],
  entryComponents: [
    AnnuityDialogComponent
  ]
})
export class AnnuityComponent implements OnInit {

  @ViewChild('activeSort', {read: MatSort, static: true}) activeSort: MatSort;
  @ViewChild('historySort', {read: MatSort, static: true}) historySort: MatSort;

  public displayedColumns: string[] = [ 'icon', 'name', 'edit', 'report' ];

  constructor (
    public _annuityService: AnnuityService,
    public _memberService: MemberService,
    public _subCategoryService: SubcategoryService,
    private dialog: MatDialog,
    private router: Router) { }

  ngOnInit () {

  }

  ngAfterViewInit () {
    this._annuityService.loadAnnuities(this.activeSort)
  }

  ngOnDestroy () {

  }

  applyFilter (filterValue: string) {
    this._annuityService.productDataSource.filter = filterValue.trim().toLowerCase();
    // if (this._annuityService.productDataSource.paginator) {
    //  this._annuityService.productDataSource.paginator.firstPage();
    // }
  }

  openDialog (entity) {

    let data: Product = new Product();

    if (entity) {
      data = entity;
    }

    this.dialog.open(AnnuityDialogComponent, {
      width: '990px',
      height: '610px',
      panelClass: 'custom-dialog-container',
      data: data
    });
  }


  gotoReport (element) {
    //console.log(JSON.stringify(element.id))
    this.router.navigate([ 'annuity-report/' + element.id + ":" + element.name + ":" + element.annuity_from ]);
  }


}
